var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12628_54483)"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    width: 54,
    height: 36,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M50.8507 28.6501C50.8507 32.6155 47.6086 35.8445 43.6271 35.8445H4.32422V7.34997C4.32422 3.38452 7.56628 0.155518 11.5478 0.155518H50.8507V28.6501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M38.0532 21.3422H41.0393C41.1247 21.3422 41.3237 21.3139 41.409 21.3139C41.9778 21.2006 42.4613 20.6907 42.4613 19.9826C42.4613 19.3028 41.9778 18.793 41.409 18.6514C41.3237 18.623 41.1531 18.623 41.0393 18.623H38.0532V21.3422Z",
    fill: "url(#paint0_linear_12628_54483)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M40.698 2.56299C37.8541 2.56299 35.5221 4.85728 35.5221 7.71807V13.0714H42.831C43.0016 13.0714 43.2007 13.0714 43.3429 13.0997C44.9923 13.1847 46.2152 14.0345 46.2152 15.5073C46.2152 16.6686 45.3905 17.66 43.8548 17.8583V17.9149C45.5327 18.0282 46.8124 18.9629 46.8124 20.4075C46.8124 21.9653 45.3905 22.985 43.5135 22.985H35.4937V33.4651H43.0869C45.9308 33.4651 48.2628 31.1708 48.2628 28.3101V2.56299H40.698Z",
    fill: "url(#paint1_linear_12628_54483)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M42.0916 15.8471C42.0916 15.1673 41.6081 14.7141 41.0393 14.6292C40.9825 14.6292 40.8403 14.6008 40.7549 14.6008H38.0532V17.0934H40.7549C40.8403 17.0934 41.0109 17.0934 41.0393 17.0651C41.6081 16.9801 42.0916 16.5269 42.0916 15.8471Z",
    fill: "url(#paint2_linear_12628_54483)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M12.0882 2.56299C9.24424 2.56299 6.91223 4.85728 6.91223 7.71807V20.4358C8.36263 21.1439 9.8699 21.5971 11.3772 21.5971C13.1688 21.5971 14.1358 20.5208 14.1358 19.0479V13.0431H18.5723V19.0196C18.5723 21.3422 17.1219 23.2399 12.2019 23.2399C9.2158 23.2399 6.88379 22.5885 6.88379 22.5885V33.4368H14.477C17.321 33.4368 19.653 31.1425 19.653 28.2817V2.56299H12.0882Z",
    fill: "url(#paint3_linear_12628_54483)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M26.393 2.56299C23.5491 2.56299 21.217 4.85728 21.217 7.71807V14.4593C22.5252 13.3547 24.8004 12.6465 28.469 12.8165C30.4313 12.9015 32.5358 13.4396 32.5358 13.4396V15.6206C31.4836 15.0825 30.2323 14.6009 28.6112 14.4876C25.8242 14.2894 24.1463 15.649 24.1463 18.0282C24.1463 20.4358 25.8242 21.7954 28.6112 21.5688C30.2323 21.4555 31.4836 20.9457 32.5358 20.4358V22.6168C32.5358 22.6168 30.4598 23.155 28.469 23.2399C24.8004 23.4099 22.5252 22.7018 21.217 21.5971V33.4935H28.8103C31.6542 33.4935 33.9862 31.1992 33.9862 28.3384V2.56299H26.393Z",
    fill: "url(#paint4_linear_12628_54483)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12628_54483",
    x1: 35.5174,
    y1: 19.986,
    x2: 48.2972,
    y2: 19.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12628_54483",
    x1: 35.517,
    y1: 18.0017,
    x2: 48.2977,
    y2: 18.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12628_54483",
    x1: 35.5171,
    y1: 15.8436,
    x2: 48.2974,
    y2: 15.8436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12628_54483",
    x1: 6.90621,
    y1: 18.0017,
    x2: 19.8839,
    y2: 18.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12628_54483",
    x1: 21.1435,
    y1: 18.0017,
    x2: 33.7478,
    y2: 18.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12628_54483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.a4f254e70e5e44eb6b0a50f753d47232.svg";
export { ForwardRef as ReactComponent };